import { Alert, AlertDescription, AlertIcon, AlertTitle, Icon, IconButton, Link, Stack } from '@ecoinvent/ui';
import mixpanel from 'mixpanel-browser';
import { BiX } from 'react-icons/bi';

import useCloseableAlertState from 'hooks/useCloseableAlertState';
import { MIXPANEL_EVENTS } from 'utilities/constants/mixpanel';

const AnnouncementBanner = () => {
  const { isOpen, onClose } = useCloseableAlertState('apiLaunchBanner2026');

  if (!isOpen) {
    return null;
  }

  const handleDiscoverMoreClick = () => {
    mixpanel.track(MIXPANEL_EVENTS.API_LAUNCH_BANNER_CLICKED, { CTA: 'Discover more here' });
  };

  const handleDismiss = () => {
    mixpanel.track(MIXPANEL_EVENTS.API_LAUNCH_BANNER_DISMISSED, { Method: 'Close Icon' });
    onClose();
  };

  return (
    <Stack p={3} px={5}>
      <Alert rounded="lg" flexDirection="row" alignItems="center">
        <AlertIcon />
        <AlertTitle fontSize={'sm'} mr={2}>
          The ecoinvent API is now available!
        </AlertTitle>
        <AlertDescription fontSize={'sm'} width={'100%'} flex={1}>
          <Link
            href="https://ecoinvent.org/blog/ecoinvent-launches-first-api/"
            isExternal
            colorScheme="blue"
            onClick={handleDiscoverMoreClick}
          >
            Discover more here
          </Link>
        </AlertDescription>
        <IconButton
          onClick={handleDismiss}
          aria-label={'close'}
          icon={<Icon as={BiX} />}
          size={'xs'}
          fontSize={'lg'}
          variant={'ghost'}
          colorScheme="blue"
        />
      </Alert>
    </Stack>
  );
};

export default AnnouncementBanner;
